// extracted by mini-css-extract-plugin
export var guides = "stateGuides-module--guides--1v0hU";